import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import flowRight from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { actions as reduxAction } from './reducers';
import SimCardsTable from './components/SimCardsTable';
import getIdFromUrl from '../../utils/getIdfromUrl';
import OrderNewSimcard from '../../modals/orderNewSimcard/OrderNewSimcard';
import getCustomJobs from '../../utils/getCustomJobs';
import { isUndefined } from '../../utils/isDefined';
import SelectClient from './components/SelectClient';
import Optional from '../../utils/optional';

function SimCards({ resetSimCards, location, clientsOptions }) {
  const client = getIdFromUrl(location);

  useEffect(() => {
    (async () => {
      await getCustomJobs();
    })();
    return resetSimCards;
    // eslint-disable-next-line
  }, [client]);

  return (
    <div>
      {isUndefined(client) && <SelectClient clientsOptions={clientsOptions} />}
      <SimCardsTable />
      <OrderNewSimcard />
    </div>
  );
}

const mapStatesToProps = ({ selectClient }) => {
  const clientsOptions = [
    { value: 'ALL', label: 'All Clients', display_name: 'All Clients' },
    ...selectClient.selectClientsList.map(option => ({
      ...option,
      value: option.id,
      label: Optional(option.display_name).or(option.name)
    }))
  ];
  return {
    clientsOptions
  };
};

const mapDispatchToProps = {
  resetSimCards: reduxAction.resetSimCards
};

export default flowRight(
  withRouter,
  connect(mapStatesToProps, mapDispatchToProps)
)(SimCards);
